var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { StyledText } from '../../../../styles/text';
export var StyledSubheading = styled(StyledText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 420px;\n"], ["\n  max-width: 420px;\n"])));
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map